/**
 * @description
 */

import { fetchData } from '@umu/umu-fetch';

import Api from '../../../../path';

export interface IInput {
    practice_id: number;
    question_ids: string; // number[].join(',');
}

export type IOutput = IQuizSectionInfo[];

export const getQuestionInfo = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.QUESTION_COLLECTION_GET_QUESTION_INFO, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
